import { Component, OnInit, ViewChild } from '@angular/core';
import { Worklog } from '../../../worklogs/worklogs.model';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { GoupedColumn, GroupFunction } from '../../../core/shared/grid/grid.model';
import { Router, ActivatedRoute } from '@angular/router';
import { IssueService } from '../../issue.service';
import { Issue } from '../../issues.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-issue-worklogs',
  templateUrl: './issue-worklogs.component.html',
  styleUrls: ['./issue-worklogs.component.scss']
})
export class IssueWorklogsComponent implements OnInit, HasPermissions {

  public worklogs: Worklog[];
  private issue: Issue;
  private worklogEdit: boolean;
  private worklogAdding: boolean;
  @ViewChild(GridComponent) grid: GridComponent;

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  private headers = [
    { displayName: 'Numer', propertyName: 'numberString', propertyType: 'string' },
    { displayName: 'Data Pracy', propertyName: 'workDate', propertyType: 'date', isInitSort: true },
    { displayName: 'Czas pracy', propertyName: 'timeSpent', propertyType: 'number' },
    { displayName: 'Czas fakturowany', propertyName: 'invoiceTime', propertyType: 'number' },
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Opis', propertyName: 'description', propertyType: 'string' }
  ];

  private columnsToGroup: GoupedColumn[] = [
    { name: 'timeSpent', func: GroupFunction.sum },
    { name: 'invoiceTime', func: GroupFunction.sum }
  ];

  ngOnInit() {
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private issueService: IssueService,
    private permissionService: PermissionsService) { }

  public setModel(worklogs: Worklog[], issue: Issue, isEditable: boolean) {
    this.setPermissions('Worklog');
    this.worklogEdit = this.permissions.canShow || this.permissions.canEdit || this.permissions.canAdd ? true : false;
    this.worklogAdding = this.permissions.canAdd && isEditable ? true : false;
    this.issue = issue;
    this.worklogs = worklogs;
  }

  get elements() {
    return this.worklogs.length > 12;
  }

  private onRowAdd(value: any) {
    if (this.issue.customerId === 0 || this.issue.projectStepId === 0 || this.issue.title === null) {
      swal('Uzupełnij wymagane dane na nagłówku zgłoszenia');
      return;
    }

    this.issueService.passIssue(this.issue);
    this.issueService.setTab(5);
    this.router.navigate(['worklogdetails', 'new'], { queryParams: { new: true }, relativeTo: this.route });
  }

  private onRowEdit(row: Worklog) {
    this.issueService.passIssue(this.issue);
    this.issueService.setTab(5);
    this.router.navigate(["worklogdetails", row.numberString], { queryParams: { id: row.id }, relativeTo: this.route });
  }
}
